/**
 * « Sorcier des marais », the swamp's shop pack (ADR 0031): a hood where
 * glowing mushrooms grow, robes of moss and bog cloth, a staff of twisted
 * root held in the weapon's place, a lantern of marsh light, and a frog
 * whose throat glows like a lamp. Looks only, over the real gear; apart on
 * purpose from the swamp's loot set (`scale-*`) and the swamp caiman.
 */
const PACK = 'bogwitch';
const piece = (id, name, slot, classes) => ({
    id,
    lootable: false,
    cosmetic: true,
    name,
    kind: 'equipment',
    slot,
    rarity: 'epic',
    ...(classes === undefined ? {} : { classes }),
    sprite: `overlay.${id}`,
    icon: `icon.${id}`,
});
const single = (id, name, blurb, priceCents) => ({
    id,
    name,
    blurb,
    pack: PACK,
    items: [{ templateId: id }],
    priceCents,
});
export const BOGWITCH_FILE = {
    templates: [
        piece('bogwitch-staff', 'Bâton des tourbières', 'weapon'),
        piece('bogwitch-hood', 'Capuche des tourbières', 'helmet'),
        piece('bogwitch-robe', 'Robe des tourbières', 'chest'),
        piece('bogwitch-gloves', 'Gants des tourbières', 'gloves'),
        piece('bogwitch-boots', 'Bottes des tourbières', 'boots'),
        piece('bogwitch-lantern', 'Lanterne des tourbières', 'offhand', ['warrior']),
        {
            id: 'lantern-frog',
            lootable: false,
            name: 'Grenouille-lanterne',
            kind: 'equipment',
            slot: 'pet',
            rarity: 'epic',
            companion: 'lantern-frog',
            icon: 'icon.lantern-frog',
        },
    ],
    offers: [
        single('bogwitch-staff', 'Bâton des tourbières', 'Une racine noueuse arrachée au marais, un feu follet vert pris dans sa tête. Animé.', 399),
        single('bogwitch-hood', 'Capuche des tourbières', 'Une capuche de mousse où poussent des champignons qui luisent d’un vert d’outre-tombe. Animée.', 299),
        single('bogwitch-robe', 'Robe des tourbières', 'Une robe de toile des marais et de mousse, qui sent la tourbe et la pluie.', 399),
        single('bogwitch-gloves', 'Gants des tourbières', 'Des gants de toile moussue aux doigts tachés de vase.', 199),
        single('bogwitch-boots', 'Bottes des tourbières', 'Des bottes de cuir noyé, faites pour marcher là où l’on s’enfonce.', 199),
        single('bogwitch-lantern', 'Lanterne des tourbières', 'Une vieille lanterne où tremble une flamme verte de feu follet. Animée.', 299),
        single('lantern-frog', 'Grenouille-lanterne', 'Une grenouille des tourbières dont la gorge s’allume comme une lanterne, qui sautille à ta droite. Animée.', 299),
        {
            id: 'bogwitch-pack',
            name: 'Sorcier des marais',
            blurb: 'Toute la tenue du sorcier (capuche, robe, gants, bottes, bâton et lanterne) et la grenouille-lanterne à tes côtés, par-dessus ton équipement.',
            pack: PACK,
            items: [
                { templateId: 'bogwitch-staff' },
                { templateId: 'bogwitch-hood' },
                { templateId: 'bogwitch-robe' },
                { templateId: 'bogwitch-gloves' },
                { templateId: 'bogwitch-boots' },
                { templateId: 'bogwitch-lantern' },
                { templateId: 'lantern-frog' },
            ],
            priceCents: 999,
            worthCents: 2193,
        },
    ],
};
//# sourceMappingURL=bogwitch.js.map